import * as React from 'react'
import Typography from '@mui/material/Typography'
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip'
import { styled } from '@mui/material/styles'

type TypographyLevel = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'subtitle1' | 'subtitle2' | 'body1' | 'body2' | 'caption' | 'overline'

interface CustomTypographyProps {
  text?: string
  color?: 'primary' | 'secondary' | 'error' | 'inherit' | 'textPrimary' | 'textSecondary' | 'action'
  level?: TypographyLevel
  fontWeight?: 'light' | 'regular' | 'medium' | 'bold'
}

const SingleLineTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
    arrow
    PopperProps={{ modifiers: [{ name: 'offset', options: { offset: [0, -20], altAxis: true } }] }}
  />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 'none'
  }
})

const CustomTypography: React.FC<CustomTypographyProps> = ({ text = '', color = 'inherit', level = 'body1', fontWeight = 'regular' }) => {
  const [isHovered, setIsHovered] = React.useState(false)

  return (
    <SingleLineTooltip title={text || 'No show'}>
      <Typography
        variant={level || 'body1'}
        color={color}
        sx={{
          cursor: 'pointer',
          fontWeight: { fontWeight },
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          maxWidth: 300
        }}
        onMouseOver={() => setIsHovered(true)}
        onMouseOut={() => setIsHovered(false)}
      >
        {text.length > 50 ? (isHovered ? text : `${text.substring(0, 50)}...`) : text}
      </Typography>
    </SingleLineTooltip>
  )
}

export default CustomTypography
